export const STATUS_MESSAGES = {
    // HTTP Status 相關
    401: '請重新登入',
    403: '無權限存取',
    404: '找不到資源',
    500: '系統錯誤，請稍後再試',
    502: '系統維護中',
    504: '請求逾時，請稍後再試',
    
    // 業務邏輯相關
    '1001': '抓取資料失敗，請再試一次',
    '1002': '查無資料',
    '1100': 'ID 錯誤',
    '1004': '名稱為必填',
    'default': '操作失敗，請再試一次',
};  